@file:Suppress("MagicNumber", "LongMethod")

package com.nonopn.skydome.common.app.pages.account

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.Search
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.RadioButton
import androidx.compose.material3.RadioButtonDefaults
import androidx.compose.material3.Switch
import androidx.compose.material3.SwitchDefaults
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

import com.nonopn.skydome.common.app.api.impl.AccountAction
import com.nonopn.skydome.common.app.api.impl.ProbeApp
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.main.model.api.Probe
import com.nonopn.skydome.common.app.pages.main.model.api.Project
import com.nonopn.skydome.common.app.pages.promocodes.PromoCodeField
import com.nonopn.skydome.common.app.pages.promocodes.isPromoFieldVisible
import com.nonopn.skydome.common.app.pages.probes.AddProbesCard
import com.nonopn.skydome.common.app.pages.probes.AccountActions
import com.nonopn.skydome.common.app.pages.probes.ProbeAction
import com.nonopn.skydome.common.app.pages.probes.ProbeFailureDialog
import com.nonopn.skydome.common.app.pages.probes.ProbeListQuery
import com.nonopn.skydome.common.app.pages.probes.ProbeOrange
import com.nonopn.skydome.common.app.pages.probes.ProbePrimaryButton
import com.nonopn.skydome.common.app.pages.probes.ProbeRow
import com.nonopn.skydome.common.app.pages.probes.ProbeSort
import com.nonopn.skydome.common.app.pages.probes.ProbeStatus
import com.nonopn.skydome.common.app.pages.probes.ProbeStatusFilter
import com.nonopn.skydome.common.app.pages.probes.TrialBannerView
import com.nonopn.skydome.common.app.pages.probes.daysRemaining
import com.nonopn.skydome.common.app.pages.probes.countProbes
import com.nonopn.skydome.common.app.pages.probes.filterProbes
import com.nonopn.skydome.common.app.pages.probes.matchedSite
import com.nonopn.skydome.common.app.pages.probes.nowSecondsUtc
import com.nonopn.skydome.common.app.pages.probes.accountActions
import com.nonopn.skydome.common.app.pages.probes.allows
import com.nonopn.skydome.common.app.pages.probes.loadAccountStatus
import com.nonopn.skydome.common.app.pages.probes.probeActionFor
import com.nonopn.skydome.common.app.pages.probes.queryKeepingVisible
import com.nonopn.skydome.common.app.pages.probes.resolveProbeStatus
import com.nonopn.skydome.common.app.pages.probes.trialBanner
import com.nonopn.skydome.common.app.pages.probes.trialProgress
import com.nonopn.skywatcher.common.api.APIUserSession
import com.nonopn.skywatcher.common.api.AlertSettingsRequest
import com.nonopn.skywatcher.common.api.ApiSession
import com.nonopn.skywatcher.common.api.BackendErrorException
import com.nonopn.skywatcher.design.theme.AppColor

import eu.codlab.compose.widgets.TextNormal

import korlibs.time.DateTime

import kotlin.math.PI
import kotlin.math.abs
import kotlin.math.cos

import androidx.compose.foundation.Canvas
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalDensity
import com.nonopn.skywatcher.maps.LatLng
import com.nonopn.skywatcher.maps.MapUtils
import com.nonopn.skywatcher.maps.providers.GoogleProvider
import com.nonopn.skydome.common.app.pages.fullscreenmap.FullscreenMapContainer
import com.nonopn.skydome.common.app.pages.fullscreenmap.MapZoomControls
import ovh.plrapps.mapcompose.api.addLayer
import ovh.plrapps.mapcompose.api.addMarker
import ovh.plrapps.mapcompose.api.addPath
import ovh.plrapps.mapcompose.api.scale
import ovh.plrapps.mapcompose.api.snapScrollTo
import androidx.compose.ui.text.style.TextAlign
import com.nonopn.skywatcher.common.app.res.account_referral_title
import com.nonopn.skywatcher.common.app.res.account_referral_coming_soon
import com.nonopn.skywatcher.common.app.res.account_referral_coming_soon_detail
import ovh.plrapps.mapcompose.core.TileStreamProvider
import ovh.plrapps.mapcompose.ui.MapUI
import ovh.plrapps.mapcompose.ui.state.MapState

import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.resources.StringResource

import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.account_active_probes
import com.nonopn.skywatcher.common.app.res.sondes_count
import com.nonopn.skywatcher.common.app.res.sondes_covered_site
import com.nonopn.skywatcher.common.app.res.sondes_filter_status
import com.nonopn.skywatcher.common.app.res.sondes_no_match
import com.nonopn.skywatcher.common.app.res.sondes_reset
import com.nonopn.skywatcher.common.app.res.sondes_search_hint
import com.nonopn.skywatcher.common.app.res.sondes_sort_by
import com.nonopn.skywatcher.common.app.res.sondes_sort_name
import com.nonopn.skywatcher.common.app.res.sondes_sort_recent
import com.nonopn.skywatcher.common.app.res.sondes_sort_sites
import com.nonopn.skywatcher.common.app.res.sondes_status_active
import com.nonopn.skywatcher.common.app.res.sondes_status_active_plural
import com.nonopn.skywatcher.common.app.res.sondes_status_all
import com.nonopn.skywatcher.common.app.res.probe_action_finalize
import com.nonopn.skywatcher.common.app.res.probe_action_upgrade
import com.nonopn.skywatcher.common.app.res.probe_badge_expired
import com.nonopn.skywatcher.common.app.res.probe_badge_trial
import com.nonopn.skywatcher.common.app.res.probe_badge_unpaid
import com.nonopn.skywatcher.common.app.res.probe_trial_rights
import com.nonopn.skywatcher.common.app.res.probe_unpaid_note
import com.nonopn.skywatcher.common.app.res.probe_valid_until
import com.nonopn.skywatcher.common.app.res.sondes_status_inactive_plural
import com.nonopn.skywatcher.common.app.res.account_alert_both
import com.nonopn.skywatcher.common.app.res.account_alert_email_desc
import com.nonopn.skywatcher.common.app.res.account_alert_email_hint
import com.nonopn.skywatcher.common.app.res.account_alert_email_toggle
import com.nonopn.skywatcher.common.app.res.account_alert_explanation
import com.nonopn.skywatcher.common.app.res.account_alert_less_1km
import com.nonopn.skywatcher.common.app.res.account_alert_less_2km
import com.nonopn.skywatcher.common.app.res.account_alert_none
import com.nonopn.skywatcher.common.app.res.account_alert_not_eligible
import com.nonopn.skywatcher.common.app.res.account_alert_radius_label
import com.nonopn.skywatcher.common.app.res.account_alert_save
import com.nonopn.skywatcher.common.app.res.account_alert_save_error
import com.nonopn.skywatcher.common.app.res.account_alert_saved
import com.nonopn.skywatcher.common.app.res.account_alert_title
import com.nonopn.skywatcher.common.app.res.account_historical_impacts
import com.nonopn.skywatcher.common.app.res.account_language_title
import com.nonopn.skywatcher.common.app.res.account_logout
import com.nonopn.skywatcher.common.app.res.account_profile_title
import com.nonopn.skywatcher.common.app.res.account_rename_failed
import com.nonopn.skywatcher.common.app.res.account_security_change_password
import com.nonopn.skywatcher.common.app.res.confirm
import com.nonopn.skywatcher.common.app.res.account_password_confirm
import com.nonopn.skywatcher.common.app.res.account_password_error_empty
import com.nonopn.skywatcher.common.app.res.account_password_error_generic
import com.nonopn.skywatcher.common.app.res.account_password_error_mismatch
import com.nonopn.skywatcher.common.app.res.account_password_error_wrong
import com.nonopn.skywatcher.common.app.res.account_password_new
import com.nonopn.skywatcher.common.app.res.account_password_old
import com.nonopn.skywatcher.common.app.res.account_password_success
import com.nonopn.skywatcher.common.app.res.account_security_title
import com.nonopn.skywatcher.common.app.res.account_status_active
import com.nonopn.skywatcher.common.app.res.account_subscription_annual
import com.nonopn.skywatcher.common.app.res.account_subscription_invoices
import com.nonopn.skywatcher.common.app.res.account_subscription_manage
import com.nonopn.skywatcher.common.app.res.account_subscription_mode_label
import com.nonopn.skywatcher.common.app.res.account_subscription_network_label
import com.nonopn.skywatcher.common.app.res.account_subscription_plan_label
import com.nonopn.skywatcher.common.app.res.account_subscription_renewal_label
import com.nonopn.skywatcher.common.app.res.account_subscription_title
import com.nonopn.skywatcher.common.app.res.account_support_contact
import com.nonopn.skywatcher.common.app.res.account_support_title
import com.nonopn.skywatcher.common.app.res.account_total_coverage
import com.nonopn.skywatcher.common.app.res.cancel
import com.nonopn.skywatcher.common.app.res.dashboard_probe_rename_action
import com.nonopn.skywatcher.common.app.res.dashboard_probe_rename_label
import com.nonopn.skywatcher.common.app.res.dashboard_probe_rename_title
import com.nonopn.skywatcher.common.app.res.ok
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.platform.UriHandler
import androidx.compose.runtime.rememberCoroutineScope
import kotlinx.coroutines.launch

// ──────────────────────────────────────────────
// Colors
// ──────────────────────────────────────────────

private object Colors {
    val activeGreen = Color(0xFF22C55E)
    val logoutRed = Color(0xFFE63B2E)
    val markerBlue = Color(0xFF2B7FE0)
    val divider = Color(0xFFE4E8EF)
    val warningOrange = Color(0xFFF59E0B)
}

// ──────────────────────────────────────────────
// Alert radius options
// ──────────────────────────────────────────────

private enum class AlertRadius(val apiValue: String) {
    LESS_1KM("less1km"),
    LESS_2KM("less2km"),
    BOTH("both"),
    NONE("none");

    companion object {
        fun fromApi(value: String?): AlertRadius = when (value) {
            "less1km" -> LESS_1KM
            "less2km" -> LESS_2KM
            "both" -> BOTH
            else -> NONE
        }
    }
}

// ──────────────────────────────────────────────
// Entry point — Account screen
// ──────────────────────────────────────────────

@Composable
fun AccountScreen(modifier: Modifier = Modifier) {
    val appModel: AppModel = LocalApp.current
    val appState by appModel.states.collectAsState()
    val uriHandler = LocalUriHandler.current
    val scope = rememberCoroutineScope()
    var billingLoading by remember { mutableStateOf(false) }

    // Fetch user profile from API
    var userProfile by remember { mutableStateOf<APIUserSession?>(null) }
    var profileLoading by remember { mutableStateOf(true) }

    LaunchedEffect(appState.apiProvider) {
        try {
            val profile = appState.apiProvider?.apiSession?.profile()
            userProfile = profile
        } catch (_: Exception) {
            // Profile unavailable — show fallback
        } finally {
            profileLoading = false
        }
    }

    // The billing portal buttons are only shown when GET /api/account/status offers ManageBilling (hidden while
    // loading or when the route fails). The portal route itself creates a Stripe session: it is only called on click.
    var canManageBilling by remember { mutableStateOf(false) }
    LaunchedEffect(appState.apiProvider) {
        canManageBilling = appModel.loadAccountStatus()?.accountActions()?.has(AccountAction.ManageBilling) == true
    }

    // Single vertical scroll for the whole page (no nested scrollable inside the sections), bounded by the
    // navigation host. The bottom insets and the end spacer keep the logout button reachable above the
    // Android navigation bar (the host's BottomSpacer gets no room) and the bottom toolbar of mobile browsers.
    val scrollState = rememberScrollState()
    Column(
        modifier = modifier
            .fillMaxSize()
            .background(AppColor.StrikeBackground)
            .verticalScroll(scrollState)
            .navigationBarsPadding()
            .padding(horizontal = 16.dp, vertical = 20.dp),
        verticalArrangement = Arrangement.spacedBy(14.dp)
    ) {
        ProfileSection(userProfile, profileLoading)
        SubscriptionSection(
            profile = userProfile,
            billingLoading = billingLoading,
            canManageBilling = canManageBilling,
            onManageSubscription = {
                scope.launch {
                    billingLoading = true
                    try {
                        // Payments always go through the user api (the admin one refuses them)
                        val api = appState.apiProvider?.apiNormal ?: return@launch
                        val answer = api.billingPortal(ProbeApp.STRIKE_RADAR)
                        // Opened after an asynchronous call: on the web a new tab would be blocked as a popup
                        openUrlAfterAsyncCall(uriHandler, answer.redirectUrl)
                    } catch (e: Exception) {
                        e.printStackTrace()
                    } finally {
                        billingLoading = false
                    }
                }
            },
        )
        ReferralSection(userProfile)
        AlertsSection(userProfile, appState.apiProvider?.apiSession)
        LanguageSection()
        SecuritySection()
        SupportSection(uriHandler = uriHandler)
        Spacer(Modifier.height(8.dp))
        LogoutButton { appModel.logout() }
        Spacer(Modifier.height(72.dp))
    }
}

// ══════════════════════════════════════════════
// Section: Profile
// ══════════════════════════════════════════════

@Composable
private fun ProfileSection(
    profile: APIUserSession?,
    isLoading: Boolean,
) {
    val displayName = buildString {
        val first = profile?.firstname?.takeIf { it.isNotBlank() }
        val last = profile?.name?.takeIf { it.isNotBlank() }
        if (first != null) append(first)
        if (first != null && last != null) append(" ")
        if (last != null) append(last)
    }.ifBlank { profile?.login ?: "—" }

    val email = profile?.email ?: "—"
    val initial = displayName.firstOrNull()?.uppercase() ?: "?"

    SectionCard(title = stringResource(Res.string.account_profile_title)) {
        if (isLoading) {
            Box(
                modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp),
                contentAlignment = Alignment.Center
            ) {
                CircularProgressIndicator(
                    modifier = Modifier.size(24.dp),
                    color = AppColor.StrikePrimary,
                    strokeWidth = 2.dp
                )
            }
        } else {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(14.dp)
            ) {
                // Avatar circle
                Box(
                    modifier = Modifier
                        .size(52.dp)
                        .clip(CircleShape)
                        .background(AppColor.StrikePrimary),
                    contentAlignment = Alignment.Center
                ) {
                    TextNormal(
                        initial,
                        fontSize = 22.sp,
                        fontWeight = FontWeight.ExtraBold,
                        color = Color.White
                    )
                }
                Column(modifier = Modifier.weight(1f)) {
                    TextNormal(
                        displayName,
                        fontSize = 17.sp,
                        fontWeight = FontWeight.Bold,
                        color = AppColor.StrikeText
                    )
                    TextNormal(
                        email,
                        fontSize = 13.sp,
                        color = AppColor.StrikeText.copy(alpha = 0.6f)
                    )
                    if (profile?.admin == true) {
                        Spacer(Modifier.height(4.dp))
                        Box(
                            modifier = Modifier
                                .clip(RoundedCornerShape(20.dp))
                                .background(
                                    AppColor.StrikePrimary.copy(alpha = 0.10f)
                                )
                                .padding(horizontal = 10.dp, vertical = 3.dp)
                        ) {
                            TextNormal(
                                "⚡ Admin",
                                fontSize = 11.sp,
                                fontWeight = FontWeight.Bold,
                                color = AppColor.StrikePrimary
                            )
                        }
                    }
                }
            }
        }
    }
}

// ══════════════════════════════════════════════
// Section: Subscription
// ══════════════════════════════════════════════

@Composable
private fun SubscriptionSection(
    profile: APIUserSession?,
    billingLoading: Boolean = false,
    canManageBilling: Boolean = false,
    onManageSubscription: () -> Unit = {},
) {
    val planLabel = stringResource(Res.string.account_subscription_plan_label)
    val renewalLabel = stringResource(Res.string.account_subscription_renewal_label)
    val modeLabel = stringResource(Res.string.account_subscription_mode_label)
    val networkLabel = stringResource(Res.string.account_subscription_network_label)
    val annualLabel = stringResource(Res.string.account_subscription_annual)

    SectionCard(title = stringResource(Res.string.account_subscription_title)) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column {
                TextNormal(
                    planLabel,
                    fontSize = 11.sp,
                    fontWeight = FontWeight.Bold,
                    color = AppColor.StrikeText.copy(alpha = 0.5f)
                )
                TextNormal(
                    "Strike Radar Pro",
                    fontSize = 18.sp,
                    fontWeight = FontWeight.ExtraBold,
                    color = AppColor.StrikePrimary
                )
            }
            Box(
                modifier = Modifier
                    .clip(RoundedCornerShape(20.dp))
                    .background(Colors.activeGreen.copy(alpha = 0.12f))
                    .padding(horizontal = 10.dp, vertical = 4.dp)
            ) {
                TextNormal(
                    stringResource(Res.string.account_status_active),
                    fontSize = 11.sp,
                    fontWeight = FontWeight.Bold,
                    color = Colors.activeGreen
                )
            }
        }
        Spacer(Modifier.height(10.dp))
        HorizontalDivider(color = Colors.divider, thickness = 1.dp)
        Spacer(Modifier.height(10.dp))
        DataRow(networkLabel, "GLD360+")
        Spacer(Modifier.height(6.dp))
        DataRow(modeLabel, annualLabel)
        // Both buttons open the Stripe billing portal: only when the account status offers ManageBilling
        if (canManageBilling) {
            Spacer(Modifier.height(14.dp))
            ActionButton(
                text = stringResource(Res.string.account_subscription_manage),
                isPrimary = true,
                enabled = !billingLoading,
            ) { onManageSubscription() }
            Spacer(Modifier.height(8.dp))
            ActionButton(
                text = stringResource(Res.string.account_subscription_invoices),
                isPrimary = false,
                enabled = !billingLoading,
            ) { onManageSubscription() }
        }
    }
}


// ══════════════════════════════════════════════
// Section: Referral program — coming soon
// ══════════════════════════════════════════════

@Composable
private fun ReferralSection(profile: APIUserSession?) {
    val titleText = stringResource(Res.string.account_referral_title)
    val comingSoonText = stringResource(Res.string.account_referral_coming_soon)
    val comingSoonDetail = stringResource(Res.string.account_referral_coming_soon_detail)

    SectionCard(title = titleText) {
        // Coming soon badge
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(12.dp))
                .background(AppColor.StrikePrimary.copy(alpha = 0.06f))
                .padding(20.dp),
            contentAlignment = Alignment.Center
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(10.dp)
            ) {
                TextNormal(
                    text = "🎁",
                    fontSize = 36.sp
                )
                TextNormal(
                    text = comingSoonText,
                    fontSize = 14.sp,
                    fontWeight = FontWeight.SemiBold,
                    color = AppColor.StrikePrimary,
                    textAlign = TextAlign.Center
                )
                TextNormal(
                    text = comingSoonDetail,
                    fontSize = 12.sp,
                    color = AppColor.StrikeText.copy(alpha = 0.6f),
                    textAlign = TextAlign.Justify
                )
            }
        }
    }
}

// ══════════════════════════════════════════════
// Section: Alerts
// ══════════════════════════════════════════════

@Composable
private fun AlertsSection(profile: APIUserSession?, apiSession: ApiSession?) {
    val radiusLabel = stringResource(Res.string.account_alert_radius_label)
    val less1km = stringResource(Res.string.account_alert_less_1km)
    val less2km = stringResource(Res.string.account_alert_less_2km)
    val both = stringResource(Res.string.account_alert_both)
    val none = stringResource(Res.string.account_alert_none)

    // Initialize from API values when available
    var selectedRadius by rememberSaveable {
        mutableStateOf(
            AlertRadius.fromApi(profile?.lightningNotificationType)
        )
    }
    var emailEnabled by rememberSaveable { mutableStateOf(true) }
    var emailAddress by rememberSaveable {
        mutableStateOf(profile?.email ?: "")
    }
    var eligible by remember { mutableStateOf(true) }
    var saving by remember { mutableStateOf(false) }
    var saveStatus by remember { mutableStateOf<Boolean?>(null) }
    val scope = rememberCoroutineScope()

    // Load the stored email alert settings once the profile is known
    LaunchedEffect(profile, apiSession) {
        if (profile != null && apiSession != null) {
            if (emailAddress.isBlank()) emailAddress = profile.email
            try {
                val settings = apiSession.alertSettings(profile.persistenceToken)
                selectedRadius = AlertRadius.fromApi(settings.zone)
                emailEnabled = settings.emailEnabled
                if (settings.email.isNotBlank()) emailAddress = settings.email
                eligible = settings.eligible
            } catch (e: Exception) {
                e.printStackTrace()
            }
        }
    }

    SectionCard(title = stringResource(Res.string.account_alert_title)) {
        // How email alerts work
        TextNormal(
            stringResource(Res.string.account_alert_explanation),
            fontSize = 13.sp,
            color = AppColor.StrikeText.copy(alpha = 0.8f),
            textAlign = TextAlign.Justify
        )
        Spacer(Modifier.height(10.dp))

        // Radius selection
        TextNormal(
            radiusLabel,
            fontSize = 13.sp,
            fontWeight = FontWeight.SemiBold,
            color = AppColor.StrikeText
        )
        Spacer(Modifier.height(6.dp))

        val options = listOf(
            AlertRadius.LESS_1KM to less1km,
            AlertRadius.LESS_2KM to less2km,
            AlertRadius.BOTH to both,
            AlertRadius.NONE to none,
        )
        options.forEach { (radius, label) ->
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(8.dp))
                    .clickable(
                        indication = null,
                        interactionSource = remember { MutableInteractionSource() }
                    ) { selectedRadius = radius }
                    .padding(vertical = 4.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                RadioButton(
                    selected = selectedRadius == radius,
                    onClick = { selectedRadius = radius },
                    colors = RadioButtonDefaults.colors(
                        selectedColor = AppColor.StrikePrimary,
                        unselectedColor = AppColor.StrikeText.copy(alpha = 0.4f)
                    )
                )
                TextNormal(
                    label,
                    fontSize = 14.sp,
                    color = if (selectedRadius == radius) {
                        AppColor.StrikeText
                    } else {
                        AppColor.StrikeText.copy(alpha = 0.7f)
                    },
                    fontWeight = if (selectedRadius == radius) {
                        FontWeight.SemiBold
                    } else {
                        FontWeight.Normal
                    }
                )
            }
        }

        Spacer(Modifier.height(8.dp))
        HorizontalDivider(color = Colors.divider, thickness = 1.dp)
        Spacer(Modifier.height(8.dp))

        // Email alerts toggle
        NotifRow(
            title = stringResource(Res.string.account_alert_email_toggle),
            description = stringResource(Res.string.account_alert_email_desc),
            checked = emailEnabled,
            onCheckedChange = { emailEnabled = it }
        )
        if (emailEnabled) {
            Spacer(Modifier.height(6.dp))
            OutlinedTextField(
                value = emailAddress,
                onValueChange = { emailAddress = it },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                label = {
                    TextNormal(
                        stringResource(Res.string.account_alert_email_hint),
                        fontSize = 12.sp
                    )
                }
            )
        }

        if (!eligible) {
            Spacer(Modifier.height(8.dp))
            TextNormal(
                stringResource(Res.string.account_alert_not_eligible),
                fontSize = 13.sp,
                color = AppColor.StrikeText.copy(alpha = 0.7f)
            )
        }

        Spacer(Modifier.height(12.dp))
        ActionButton(
            text = stringResource(Res.string.account_alert_save),
            isPrimary = true
        ) {
            if (saving || profile == null || apiSession == null) return@ActionButton
            scope.launch {
                saving = true
                saveStatus = try {
                    val settings = apiSession.alertSettings(
                        token = profile.persistenceToken,
                        request = AlertSettingsRequest(
                            zone = selectedRadius.apiValue,
                            emailEnabled = emailEnabled,
                            email = emailAddress.trim(),
                        )
                    )
                    eligible = settings.eligible
                    true
                } catch (e: Exception) {
                    e.printStackTrace()
                    false
                } finally {
                    saving = false
                }
            }
        }

        saveStatus?.let { ok ->
            Spacer(Modifier.height(6.dp))
            TextNormal(
                stringResource(if (ok) Res.string.account_alert_saved else Res.string.account_alert_save_error),
                fontSize = 13.sp,
                color = if (ok) AppColor.StrikePrimary else AppColor.StrikeText.copy(alpha = 0.7f)
            )
        }
    }
}

// ══════════════════════════════════════════════
// Section: Language
// ══════════════════════════════════════════════

@Composable
private fun LanguageSection() {
    val appModel = LocalApp.current
    val appState by appModel.states.collectAsState()
    val selected = appState.appLanguage
    val languages = listOf(
        Triple("fr", "🇫🇷", "FR"),
        Triple("en", "🇬🇧", "EN"),
        Triple("es", "🇪🇸", "ES"),
        Triple("pt", "🇧🇷", "PT"),
    )
    SectionCard(title = stringResource(Res.string.account_language_title)) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(10.dp)
        ) {
            languages.forEach { (code, flag, label) ->
                val isSelected = selected == code
                Column(
                    modifier = Modifier
                        .weight(1f)
                        .clip(RoundedCornerShape(10.dp))
                        .background(
                            if (isSelected) AppColor.StrikePrimary.copy(alpha = 0.12f)
                            else AppColor.StrikeBackground
                        )
                        .clickable(
                            indication = null,
                            interactionSource = remember { MutableInteractionSource() }
                        ) { appModel.setLanguage(code) }
                        .padding(vertical = 10.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    TextNormal(flag, fontSize = 22.sp)
                    Spacer(Modifier.height(4.dp))
                    TextNormal(
                        text = label,
                        fontSize = 13.sp,
                        fontWeight = if (isSelected) FontWeight.Bold else FontWeight.Normal,
                        color = if (isSelected) AppColor.StrikePrimary
                        else AppColor.StrikeText.copy(alpha = 0.6f)
                    )
                }
            }
        }
    }
}

// ══════════════════════════════════════════════
// Section: Security
// ══════════════════════════════════════════════

@Composable
private fun SecuritySection() {
    var showPasswordDialog by remember { mutableStateOf(false) }
    var passwordChanged by remember { mutableStateOf(false) }

    if (showPasswordDialog) {
        ChangePasswordDialog(
            onDismiss = { showPasswordDialog = false },
            onSuccess = {
                showPasswordDialog = false
                passwordChanged = true
            }
        )
    }

    SectionCard(title = stringResource(Res.string.account_security_title)) {
        ActionButton(
            text = stringResource(Res.string.account_security_change_password),
            isPrimary = false
        ) {
            passwordChanged = false
            showPasswordDialog = true
        }
        if (passwordChanged) {
            Spacer(Modifier.height(8.dp))
            TextNormal(
                text = stringResource(Res.string.account_password_success),
                fontSize = 13.sp,
                color = Colors.activeGreen
            )
        }
    }
}

private enum class PasswordError(val message: StringResource) {
    EMPTY(Res.string.account_password_error_empty),
    MISMATCH(Res.string.account_password_error_mismatch),
    WRONG_OLD(Res.string.account_password_error_wrong),
    GENERIC(Res.string.account_password_error_generic),
}

@Composable
private fun ChangePasswordDialog(
    onDismiss: () -> Unit,
    onSuccess: () -> Unit,
) {
    val appModel: AppModel = LocalApp.current
    var oldPassword by remember { mutableStateOf("") }
    var newPassword by remember { mutableStateOf("") }
    var confirmPassword by remember { mutableStateOf("") }
    var loading by remember { mutableStateOf(false) }
    var error by remember { mutableStateOf<PasswordError?>(null) }

    val submit = {
        error = when {
            oldPassword.isEmpty() || newPassword.isEmpty() || confirmPassword.isEmpty() -> PasswordError.EMPTY
            newPassword != confirmPassword -> PasswordError.MISMATCH
            else -> null
        }
        if (error == null) {
            loading = true
            appModel.changePassword(oldPassword, newPassword, confirmPassword) { err ->
                loading = false
                error = when {
                    err == null -> null
                    // The backend answers 401 when the current password is wrong
                    err is BackendErrorException && err.code.value == 401 -> PasswordError.WRONG_OLD
                    else -> PasswordError.GENERIC
                }
                if (err == null) onSuccess()
            }
        }
    }

    AlertDialog(
        onDismissRequest = { if (!loading) onDismiss() },
        title = {
            TextNormal(stringResource(Res.string.account_security_change_password), fontWeight = FontWeight.Bold)
        },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
                PasswordField(
                    value = oldPassword,
                    label = stringResource(Res.string.account_password_old)
                ) {
                    oldPassword = it
                    error = null
                }
                PasswordField(
                    value = newPassword,
                    label = stringResource(Res.string.account_password_new)
                ) {
                    newPassword = it
                    error = null
                }
                PasswordField(
                    value = confirmPassword,
                    label = stringResource(Res.string.account_password_confirm)
                ) {
                    confirmPassword = it
                    error = null
                }
                error?.let {
                    TextNormal(
                        text = stringResource(it.message),
                        fontSize = 13.sp,
                        color = Colors.logoutRed
                    )
                }
            }
        },
        confirmButton = {
            TextButton(enabled = !loading, onClick = submit) {
                if (loading) {
                    CircularProgressIndicator(
                        modifier = Modifier.size(18.dp),
                        strokeWidth = 2.dp,
                        color = AppColor.StrikePrimary
                    )
                } else {
                    TextNormal(
                        text = stringResource(Res.string.confirm),
                        color = AppColor.StrikePrimary,
                        fontWeight = FontWeight.Bold
                    )
                }
            }
        },
        dismissButton = {
            TextButton(enabled = !loading, onClick = onDismiss) {
                TextNormal(stringResource(Res.string.cancel), color = AppColor.StrikeText.copy(alpha = 0.6f))
            }
        }
    )
}

@Composable
private fun PasswordField(
    value: String,
    label: String,
    onValueChange: (String) -> Unit,
) {
    OutlinedTextField(
        modifier = Modifier.fillMaxWidth(),
        value = value,
        onValueChange = onValueChange,
        singleLine = true,
        label = { TextNormal(label) },
        visualTransformation = PasswordVisualTransformation(),
        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Password),
    )
}

// ══════════════════════════════════════════════
// Section: Support
// ══════════════════════════════════════════════

@Composable
private fun SupportSection(uriHandler: UriHandler) {
    SectionCard(title = stringResource(Res.string.account_support_title)) {
        ActionButton(
            text = stringResource(Res.string.account_support_contact),
            isPrimary = false
        ) { uriHandler.openUri("mailto:support@lpsfr.com") }
        Spacer(Modifier.height(10.dp))
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.Center
        ) {
            TextNormal(
                "Strike Radar v1.0.0",
                fontSize = 11.sp,
                color = AppColor.StrikeText.copy(alpha = 0.35f)
            )
        }
    }
}

// ══════════════════════════════════════════════
// Account screen reusable components
// ══════════════════════════════════════════════

@Composable
private fun SectionCard(
    modifier: Modifier = Modifier,
    title: String,
    content: @Composable () -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(AppColor.StrikeCard)
            .padding(16.dp)
    ) {
        TextNormal(
            text = title,
            fontSize = 13.sp,
            fontWeight = FontWeight.Bold,
            color = AppColor.StrikeText.copy(alpha = 0.5f)
        )
        Spacer(Modifier.height(12.dp))
        content()
    }
}

@Composable
private fun DataRow(label: String, value: String) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween
    ) {
        TextNormal(
            label,
            fontSize = 13.sp,
            color = AppColor.StrikeText.copy(alpha = 0.6f)
        )
        TextNormal(
            value,
            fontSize = 13.sp,
            fontWeight = FontWeight.SemiBold,
            color = AppColor.StrikeText
        )
    }
}

@Composable
private fun NotifRow(
    title: String,
    description: String,
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(modifier = Modifier.weight(1f)) {
            TextNormal(
                title,
                fontSize = 14.sp,
                fontWeight = FontWeight.SemiBold,
                color = AppColor.StrikeText
            )
            TextNormal(
                description,
                fontSize = 12.sp,
                color = AppColor.StrikeText.copy(alpha = 0.5f)
            )
        }
        Spacer(Modifier.width(12.dp))
        Switch(
            checked = checked,
            onCheckedChange = onCheckedChange,
            colors = SwitchDefaults.colors(
                checkedThumbColor = Color.White,
                checkedTrackColor = AppColor.StrikePrimary,
                uncheckedThumbColor = Color.White,
                uncheckedTrackColor = AppColor.StrikeText.copy(alpha = 0.2f)
            )
        )
    }
}

@Composable
private fun ActionButton(
    text: String,
    isPrimary: Boolean,
    isDanger: Boolean = false,
    enabled: Boolean = true,
    onClick: () -> Unit,
) {
    val alpha = if (enabled) 1f else 0.4f
    val bgColor = when {
        isDanger -> Colors.logoutRed.copy(alpha = 0.08f)
        isPrimary -> AppColor.StrikePrimary
        else -> AppColor.StrikeBackground
    }
    val textColor = when {
        isDanger -> Colors.logoutRed
        isPrimary -> Color.White
        else -> AppColor.StrikeText
    }
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(10.dp))
            .background(bgColor.copy(alpha = bgColor.alpha * alpha))
            .then(
                if (enabled) {
                    Modifier.clickable(
                        indication = null,
                        interactionSource = remember { MutableInteractionSource() }
                    ) { onClick() }
                } else {
                    Modifier
                }
            )
            .padding(vertical = 13.dp),
        contentAlignment = Alignment.Center
    ) {
        TextNormal(
            text,
            fontSize = 14.sp,
            fontWeight = FontWeight.SemiBold,
            color = textColor
        )
    }
}

@Composable
private fun LogoutButton(onClick: () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(Colors.logoutRed.copy(alpha = 0.10f))
            .clickable(
                indication = null,
                interactionSource = remember { MutableInteractionSource() }
            ) { onClick() }
            .padding(vertical = 16.dp),
        contentAlignment = Alignment.Center
    ) {
        TextNormal(
            "🚪 ${stringResource(Res.string.account_logout)}",
            fontSize = 15.sp,
            fontWeight = FontWeight.Bold,
            color = Colors.logoutRed
        )
    }
}

// ══════════════════════════════════════════════
// Composables used by ProbesScreen (internal)
// ══════════════════════════════════════════════

@Composable
internal fun SondesTab(
    state: AccountState,
    model: AccountModel,
    onNewProbe: (() -> Unit)?,
    onSelectProbe: (String) -> Unit = {},
    onNavigateToProjects: (String?) -> Unit = {},
    // Opens the probe creation screen (null while the feature flag hides it)
    onCreateProbes: (() -> Unit)? = null,
) {
    val sondesUriHandler = LocalUriHandler.current
    state.probeCallError?.let { error ->
        ProbeFailureDialog(
            error = error,
            onDismiss = { model.clearProbeCallError() },
            onPayExisting = { model.payExistingProbe(sondesUriHandler) },
            canPayExisting = state.actions.allows(AccountAction.Upgrade)
        )
    }
    if (state.renameError != null) {
        AlertDialog(
            onDismissRequest = { model.clearRenameError() },
            confirmButton = {
                TextButton(onClick = { model.clearRenameError() }) { TextNormal(stringResource(Res.string.ok)) }
            },
            title = { TextNormal(stringResource(Res.string.account_rename_failed), fontWeight = FontWeight.Bold) },
            text = {
                TextNormal(state.renameError ?: "Unable to rename this probe. Please try again later.")
            }
        )
    }
    // "Add probes" only when the account status offers AddProbes (always offered when the status is unknown)
    val createProbes = onCreateProbes.takeIf { state.actions.allows(AccountAction.AddProbes) }
    when {
        state.isLoading -> LoadingCenter()
        state.error != null -> ErrorCenter(state.error)
        state.probes.isEmpty() -> EmptyProbesCenter(onNewProbe, createProbes)
        else -> SondesContent(state, model, onNewProbe, onSelectProbe, onNavigateToProjects, createProbes)
    }
}

@Composable
private fun SondesContent(
    state: AccountState,
    model: AccountModel,
    onNewProbe: (() -> Unit)?,
    onSelectProbe: (String) -> Unit,
    onNavigateToProjects: (String?) -> Unit = {},
    onCreateProbes: (() -> Unit)? = null,
) {
    val uriHandler = LocalUriHandler.current
    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(horizontal = 16.dp)
    ) {
        Spacer(Modifier.height(12.dp))
        Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                val activeCount = state.probes.count { it.enabled }
                KpiCard(
                    modifier = Modifier.weight(1f),
                    value = "$activeCount",
                    label = stringResource(Res.string.account_active_probes),
                    valueColor = AppColor.StrikePrimary,
                )
                val totalKm2 = state.probes.filter { it.enabled }
                    .sumOf { PI * it.radiusKm * it.radiusKm }.toLong()
                KpiCard(
                    modifier = Modifier.weight(1f),
                    value = "~$totalKm2 km²",
                    label = stringResource(Res.string.account_total_coverage),
                    valueColor = AppColor.StrikePrimary,
                )
                KpiCard(
                    modifier = Modifier.weight(1f),
                    value = "${state.totalImpacts}",
                    label = stringResource(Res.string.account_historical_impacts),
                    valueColor = AppColor.StrikeAccent,
                )
            }
            onNewProbe?.let { NewProbeCta(onClick = it) }
            // J-7 / J-1 reminder of the end of the trial
            trialBanner(state.probes.map { it.statusInput() }, nowSecondsUtc())?.let { banner ->
                TrialBannerView(banner = banner, onUpgrade = null)
            }
            // "Promo code" before the payment of an unpaid probe or of the demo upgrade (logged in account)
            val promoAppState by LocalApp.current.states.collectAsState()
            val loggedIn = promoAppState.apiProvider?.let { it.apiNormal != null || it.apiAdmin != null } == true
            val payable = remember(state.probes, state.actions) {
                val now = nowSecondsUtc()
                state.probes.any { probe ->
                    val input = probe.statusInput()
                    probeActionFor(input, resolveProbeStatus(input, now), state.actions) != ProbeAction.None
                }
            }
            if (payable && isPromoFieldVisible(loggedIn, state.subscriptionRunning, isDemoRequest = false)) {
                PromoCodeField(
                    state = state.promo,
                    onInput = { model.onPromoInput(it) },
                    onApply = { model.applyPromo() },
                    onRemove = { model.removePromo() },
                    enabled = state.busyProbeUuid == null,
                )
            }
        }
        Spacer(Modifier.height(10.dp))
        // Covered LPS Manager sites of each probe, computed once per data refresh
        val nearbyByProbe = remember(state.probes, state.lpsProjects) {
            state.probes.associate { probe ->
                probe.uuid to state.lpsProjects.map { project ->
                    project to AccountModel.haversineKm(
                        probe.latitude, probe.longitude,
                        project.latitude, project.longitude
                    )
                }.filter { (_, dist) -> dist <= probe.radiusKm }
                    .sortedBy { (_, dist) -> dist }
            }
        }
        val rows = remember(state.probes, nearbyByProbe) {
            state.probes.map { probe ->
                ProbeRow(
                    uuid = probe.uuid,
                    name = probe.name,
                    enabled = probe.enabled,
                    createdAtSecondsUtc = probe.createdAtSecondsUtc,
                    siteNames = nearbyByProbe[probe.uuid].orEmpty().map { (project, _) -> project.name }
                )
            }
        }
        var query by remember { mutableStateOf(ProbeListQuery()) }
        // A probe requested from elsewhere (dashboard map pop-up) must stay visible: reset the filters if needed
        LaunchedEffect(state.selectedProbeUuid, rows) {
            query = queryKeepingVisible(rows, query, state.selectedProbeUuid)
        }
        val visibleRows = remember(rows, query) { filterProbes(rows, query) }
        val probesByUuid = remember(state.probes) { state.probes.associateBy { it.uuid } }
        LazyVerticalGrid(
            columns = GridCells.Fixed(2),
            modifier = Modifier
                .weight(1f)
                .fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(10.dp),
            horizontalArrangement = Arrangement.spacedBy(10.dp)
        ) {
            item(span = { GridItemSpan(maxCurrentLineSpan) }) {
                ProbesFilterBar(
                    query = query,
                    shown = countProbes(rows, query).shown,
                    total = rows.size,
                    onQueryChange = { query = it }
                )
            }
            if (visibleRows.isEmpty()) {
                item(span = { GridItemSpan(maxCurrentLineSpan) }) {
                    Box(Modifier.fillMaxWidth().padding(vertical = 28.dp), contentAlignment = Alignment.Center) {
                        TextNormal(
                            stringResource(Res.string.sondes_no_match),
                            fontSize = 13.sp,
                            textAlign = TextAlign.Center,
                            color = AppColor.StrikeText.copy(alpha = 0.55f)
                        )
                    }
                }
            }
            items(visibleRows, key = { it.uuid }) { row ->
                val probe = probesByUuid[row.uuid] ?: return@items
                val nearby = nearbyByProbe[probe.uuid].orEmpty()
                SondeCard(
                    modifier = Modifier,
                    probe = probe,
                    nearbyProjects = nearby,
                    isSelected = state.selectedProbeUuid == probe.uuid,
                    onSelect = { onSelectProbe(probe.uuid) },
                    onRenameConfirm = { newName -> model.confirmRename(probe.uuid, newName) },
                    onNavigateToProjects = onNavigateToProjects,
                    matchedSiteName = matchedSite(row, query.search),
                    actionBusy = state.busyProbeUuid == probe.uuid,
                    accountActions = state.actions,
                    onProbeAction = { model.payProbe(probe.uuid, probe.statusInput(), uriHandler) }
                )
            }
            onCreateProbes?.let { create ->
                item(span = { GridItemSpan(maxCurrentLineSpan) }) {
                    AddProbesCard(onClick = create)
                }
            }
            item(span = { GridItemSpan(maxCurrentLineSpan) }) {
                Spacer(Modifier.height(16.dp))
            }
        }
    }
}

/** Search field, status filter, sort and "N of M" counter above the probe cards. */
@Composable
private fun ProbesFilterBar(
    query: ProbeListQuery,
    shown: Int,
    total: Int,
    onQueryChange: (ProbeListQuery) -> Unit,
) {
    Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
        OutlinedTextField(
            modifier = Modifier.fillMaxWidth(),
            value = query.search,
            onValueChange = { onQueryChange(query.copy(search = it)) },
            placeholder = {
                TextNormal(
                    text = stringResource(Res.string.sondes_search_hint),
                    fontSize = 13.sp,
                    color = AppColor.StrikeText.copy(alpha = 0.4f)
                )
            },
            leadingIcon = {
                Icon(
                    imageVector = Icons.Rounded.Search,
                    contentDescription = null,
                    tint = AppColor.StrikeText.copy(alpha = 0.5f)
                )
            },
            singleLine = true,
            keyboardOptions = KeyboardOptions(imeAction = ImeAction.Search),
            shape = RoundedCornerShape(10.dp),
            colors = OutlinedTextFieldDefaults.colors(
                focusedBorderColor = AppColor.StrikePrimary,
                unfocusedBorderColor = AppColor.StrikeText.copy(alpha = 0.2f)
            )
        )
        ProbeChipRow(label = stringResource(Res.string.sondes_filter_status)) {
            ProbeStatusFilter.values().forEach { status ->
                ProbeChip(
                    label = stringResource(
                        when (status) {
                            ProbeStatusFilter.ALL -> Res.string.sondes_status_all
                            ProbeStatusFilter.ACTIVE -> Res.string.sondes_status_active_plural
                            ProbeStatusFilter.INACTIVE -> Res.string.sondes_status_inactive_plural
                        }
                    ),
                    selected = query.status == status,
                    onClick = { onQueryChange(query.copy(status = status)) }
                )
            }
        }
        ProbeChipRow(label = stringResource(Res.string.sondes_sort_by)) {
            ProbeSort.values().forEach { sort ->
                ProbeChip(
                    label = stringResource(
                        when (sort) {
                            ProbeSort.NAME -> Res.string.sondes_sort_name
                            ProbeSort.RECENT -> Res.string.sondes_sort_recent
                            ProbeSort.SITES -> Res.string.sondes_sort_sites
                        }
                    ),
                    selected = query.sort == sort,
                    onClick = { onQueryChange(query.copy(sort = sort)) }
                )
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            TextNormal(
                stringResource(Res.string.sondes_count, shown, total),
                fontSize = 11.sp,
                color = AppColor.StrikeText.copy(alpha = 0.6f)
            )
            Box(
                modifier = Modifier
                    .clip(RoundedCornerShape(6.dp))
                    .clickable(enabled = !query.isDefault) { onQueryChange(ProbeListQuery()) }
                    .padding(horizontal = 6.dp, vertical = 4.dp)
            ) {
                TextNormal(
                    stringResource(Res.string.sondes_reset),
                    fontSize = 12.sp,
                    fontWeight = FontWeight.SemiBold,
                    color = if (query.isDefault) AppColor.StrikeText.copy(alpha = 0.3f) else AppColor.StrikePrimary
                )
            }
        }
    }
}

@Composable
private fun ProbeChipRow(label: String, content: @Composable () -> Unit) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        Box(Modifier.width(56.dp)) {
            TextNormal(
                label,
                fontSize = 10.sp,
                color = AppColor.StrikeText.copy(alpha = 0.5f)
            )
        }
        Row(
            modifier = Modifier.horizontalScroll(rememberScrollState()),
            horizontalArrangement = Arrangement.spacedBy(6.dp)
        ) { content() }
    }
}

@Composable
private fun ProbeChip(label: String, selected: Boolean, onClick: () -> Unit) {
    Box(
        modifier = Modifier
            .clip(RoundedCornerShape(16.dp))
            .background(if (selected) AppColor.StrikePrimary else AppColor.StrikeCard)
            .clickable(onClick = onClick)
            .padding(horizontal = 12.dp, vertical = 5.dp),
        contentAlignment = Alignment.Center
    ) {
        TextNormal(
            text = label,
            fontSize = 11.sp,
            fontWeight = if (selected) FontWeight.SemiBold else FontWeight.Normal,
            color = if (selected) Color.White else AppColor.StrikeText.copy(alpha = 0.7f)
        )
    }
}

@Composable
internal fun EmptyProbesCenter(onNewProbe: (() -> Unit)?, onCreateProbes: (() -> Unit)? = null) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .padding(16.dp),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            TextNormal(
                "Aucune sonde configurée",
                fontSize = 14.sp,
                color = AppColor.StrikeText.copy(alpha = 0.5f)
            )
            Spacer(Modifier.height(14.dp))
            onNewProbe?.let { NewProbeCta(onClick = it) }
            onCreateProbes?.let { AddProbesCard(onClick = it) }
        }
    }
}

@Composable
internal fun NewProbeCta(onClick: () -> Unit) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(AppColor.StrikePrimary.copy(alpha = 0.10f))
            .clickable(
                interactionSource = remember { MutableInteractionSource() },
                indication = null
            ) { onClick() }
            .padding(horizontal = 16.dp, vertical = 14.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(modifier = Modifier.weight(1f)) {
            TextNormal(
                "Nouvelle sonde",
                fontSize = 15.sp,
                fontWeight = FontWeight.Bold,
                color = AppColor.StrikePrimary
            )
            TextNormal(
                "Ajouter une zone de surveillance",
                fontSize = 12.sp,
                color = AppColor.StrikeText.copy(alpha = 0.65f)
            )
        }
        TextNormal("+", fontSize = 24.sp, fontWeight = FontWeight.Bold, color = AppColor.StrikePrimary)
    }
}

@Composable
internal fun SondeCard(
    modifier: Modifier = Modifier,
    probe: Probe,
    nearbyProjects: List<Pair<Project, Double>> = emptyList(),
    isSelected: Boolean = false,
    onSelect: (() -> Unit)? = null,
    onRenameConfirm: (String) -> Unit = {},
    onNavigateToProjects: (String?) -> Unit = {},
    // Covered site matching the current search (when the probe name itself does not match)
    matchedSiteName: String? = null,
    // Trial / unpaid actions (data driven: only shown when the server returns a status)
    actionBusy: Boolean = false,
    // Buttons allowed by the account status (null = unknown: previous rule)
    accountActions: AccountActions? = null,
    onProbeAction: () -> Unit = {},
) {
    val nowSeconds = remember { nowSecondsUtc() }
    val statusInput = probe.statusInput()
    val probeStatus = resolveProbeStatus(statusInput, nowSeconds)
    val trialEndsAt = statusInput.trialEnd
    val statusColor = when (probeStatus) {
        ProbeStatus.Active -> Colors.activeGreen
        ProbeStatus.Trial -> AppColor.StrikePrimary
        else -> AppColor.StrikeText.copy(alpha = 0.4f)
    }
    val statusLabel = when (probeStatus) {
        ProbeStatus.Trial -> stringResource(
            Res.string.probe_badge_trial,
            if (trialEndsAt != null) daysRemaining(nowSeconds, trialEndsAt) else 0
        )
        ProbeStatus.Unpaid -> stringResource(Res.string.probe_badge_unpaid)
        ProbeStatus.Expired -> stringResource(Res.string.probe_badge_expired)
        ProbeStatus.Active -> stringResource(Res.string.sondes_status_active)
    }
    var showRenameDialog by remember { mutableStateOf(false) }
    var renameText by remember(probe.uuid, probe.name) { mutableStateOf(probe.name) }

    if (showRenameDialog) {
        AlertDialog(
            onDismissRequest = { showRenameDialog = false },
            title = { TextNormal(stringResource(Res.string.dashboard_probe_rename_title), fontWeight = FontWeight.Bold) },
            text = {
                OutlinedTextField(
                    value = renameText,
                    onValueChange = { renameText = it },
                    singleLine = true,
                    label = { TextNormal(stringResource(Res.string.dashboard_probe_rename_label)) }
                )
            },
            confirmButton = {
                TextButton(onClick = {
                    onRenameConfirm(renameText)
                    showRenameDialog = false
                }) {
                    TextNormal(stringResource(Res.string.dashboard_probe_rename_action), color = AppColor.StrikePrimary, fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { showRenameDialog = false }) {
                    TextNormal(stringResource(Res.string.cancel), color = AppColor.StrikeText.copy(alpha = 0.6f))
                }
            }
        )
    }

    Row(
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(AppColor.StrikeCard)
            .clickable { onSelect?.invoke() }
            .padding(14.dp),
        horizontalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        // Info column gets more space so long probe names are readable
        Column(modifier = Modifier.weight(1.4f)) {
            // Name row: full width with rename icon at the end
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                TextNormal(
                    probe.name,
                    modifier = Modifier.weight(1f),
                    fontSize = 15.sp,
                    fontWeight = FontWeight.Bold,
                    color = AppColor.StrikeText
                )
                Box(
                    modifier = Modifier
                        .clip(RoundedCornerShape(8.dp))
                        .clickable(
                            interactionSource = remember { MutableInteractionSource() },
                            indication = null
                        ) { showRenameDialog = true }
                        .padding(horizontal = 6.dp, vertical = 4.dp),
                    contentAlignment = Alignment.Center
                ) { TextNormal("✏️", fontSize = 14.sp) }
            }
            // Status badge on its own row below the name
            Spacer(Modifier.height(3.dp))
            Box(
                modifier = Modifier
                    .clip(RoundedCornerShape(20.dp))
                    .background(statusColor.copy(alpha = 0.12f))
                    .padding(horizontal = 8.dp, vertical = 3.dp)
            ) {
                TextNormal(
                    "● $statusLabel",
                    fontSize = 10.sp,
                    fontWeight = FontWeight.Bold,
                    color = statusColor
                )
            }
            ProbeStatusDetails(
                probe = probe,
                status = probeStatus,
                nowSeconds = nowSeconds,
                action = probeActionFor(statusInput, probeStatus, accountActions),
                busy = actionBusy,
                onAction = onProbeAction
            )
            val creationDate = probe.createdAtSecondsUtc.toShortDateOrNull()
            if (creationDate != null) {
                Spacer(Modifier.height(3.dp))
                TextNormal(
                    "📅 Créée le $creationDate",
                    fontSize = 10.sp,
                    color = AppColor.StrikeText.copy(alpha = 0.55f)
                )
            }
            if (matchedSiteName != null) {
                Spacer(Modifier.height(3.dp))
                TextNormal(
                    stringResource(Res.string.sondes_covered_site, matchedSiteName),
                    fontSize = 10.sp,
                    fontWeight = FontWeight.SemiBold,
                    color = AppColor.StrikePrimary
                )
            }
            Spacer(Modifier.height(6.dp))
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(6.dp))
                    .background(AppColor.StrikeBackground)
                    .padding(horizontal = 8.dp, vertical = 6.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                TextNormal("📍 ", fontSize = 12.sp)
                TextNormal(
                    "${probe.latitude.formatCoord4()}°N",
                    fontSize = 11.sp,
                    color = AppColor.StrikeText.copy(alpha = 0.7f),
                    fontFamily = FontFamily.Monospace
                )
                TextNormal(" | ", fontSize = 11.sp, color = AppColor.StrikeText.copy(alpha = 0.3f))
                TextNormal(
                    "${probe.longitude.formatCoord4()}°E",
                    fontSize = 11.sp,
                    color = AppColor.StrikeText.copy(alpha = 0.7f),
                    fontFamily = FontFamily.Monospace
                )
            }
            if (nearbyProjects.isNotEmpty()) {
                Spacer(Modifier.height(6.dp))
                var projectsExpanded by remember { mutableStateOf(false) }
                val projectThreshold = 10
                val visibleProjects = if (projectsExpanded || nearbyProjects.size <= projectThreshold) {
                    nearbyProjects
                } else {
                    nearbyProjects.take(projectThreshold)
                }
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clip(RoundedCornerShape(6.dp))
                        .background(AppColor.StrikeBackground)
                        .padding(horizontal = 8.dp, vertical = 6.dp),
                    verticalArrangement = Arrangement.spacedBy(3.dp)
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            TextNormal("🏗️ ", fontSize = 12.sp)
                            TextNormal(
                                "Projets LPS Manager",
                                fontSize = 11.sp,
                                fontWeight = FontWeight.SemiBold,
                                color = AppColor.StrikeText.copy(alpha = 0.7f)
                            )
                        }
                        Box(
                            modifier = Modifier
                                .clip(RoundedCornerShape(20.dp))
                                .background(AppColor.StrikePrimary.copy(alpha = 0.10f))
                                .padding(horizontal = 7.dp, vertical = 2.dp)
                        ) {
                            TextNormal(
                                "${nearbyProjects.size}",
                                fontSize = 11.sp,
                                fontWeight = FontWeight.Bold,
                                color = AppColor.StrikePrimary
                            )
                        }
                    }
                    visibleProjects.forEach { (project, _) ->
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clip(RoundedCornerShape(4.dp))
                                .clickable(
                                    indication = null,
                                    interactionSource = remember { MutableInteractionSource() }
                                ) { onNavigateToProjects(project.uuid) }
                                .padding(horizontal = 4.dp, vertical = 3.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            TextNormal("📁 ", fontSize = 11.sp)
                            TextNormal(
                                project.name,
                                fontSize = 11.sp,
                                color = AppColor.StrikePrimary,
                                modifier = Modifier.weight(1f)
                            )
                        }
                    }
                    if (!projectsExpanded && nearbyProjects.size > projectThreshold) {
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clip(RoundedCornerShape(6.dp))
                                .clickable(
                                    indication = null,
                                    interactionSource = remember { MutableInteractionSource() }
                                ) { projectsExpanded = true }
                                .padding(vertical = 4.dp),
                            contentAlignment = Alignment.Center
                        ) {
                            TextNormal(
                                "Voir ${nearbyProjects.size - projectThreshold} autres ▾",
                                fontSize = 11.sp,
                                color = AppColor.StrikePrimary,
                                fontWeight = FontWeight.SemiBold
                            )
                        }
                    }
                }
            }
        }
        if (probe.latitude != 0.0 && probe.longitude != 0.0) {
            StaticMapTile(
                lat = probe.latitude,
                lon = probe.longitude,
                radiusKm = probe.radiusKm,
                modifier = Modifier
                    .weight(1f)
                    .aspectRatio(1f)
                    .clip(RoundedCornerShape(10.dp))
            )
        }
    }
}

/** Trial progress, unpaid note, validity date and the upgrade / finalize button of a probe card. */
@Composable
private fun ProbeStatusDetails(
    probe: Probe,
    status: ProbeStatus,
    nowSeconds: Long,
    action: ProbeAction,
    busy: Boolean,
    onAction: () -> Unit,
) {
    val trialEndsAt = probe.statusInput().trialEnd
    when (status) {
        ProbeStatus.Trial -> {
            Spacer(Modifier.height(4.dp))
            TextNormal(
                stringResource(Res.string.probe_trial_rights),
                fontSize = 10.sp,
                color = AppColor.StrikeText.copy(alpha = 0.55f)
            )
            if (trialEndsAt != null) {
                Spacer(Modifier.height(4.dp))
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(5.dp)
                        .clip(RoundedCornerShape(3.dp))
                        .background(AppColor.StrikeText.copy(alpha = 0.10f))
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth(trialProgress(nowSeconds, trialEndsAt))
                            .height(5.dp)
                            .background(AppColor.StrikePrimary)
                    )
                }
            }
        }
        ProbeStatus.Unpaid -> {
            Spacer(Modifier.height(4.dp))
            TextNormal(
                stringResource(Res.string.probe_unpaid_note),
                fontSize = 10.sp,
                color = AppColor.StrikeText.copy(alpha = 0.55f)
            )
        }
        ProbeStatus.Active -> {
            val validUntil = probe.validUntilSecondsUtc?.toShortDateOrNull()
            if (validUntil != null) {
                Spacer(Modifier.height(4.dp))
                TextNormal(
                    stringResource(Res.string.probe_valid_until, validUntil),
                    fontSize = 10.sp,
                    color = AppColor.StrikeText.copy(alpha = 0.55f)
                )
            }
        }
        ProbeStatus.Expired -> Unit
    }
    if (action != ProbeAction.None) {
        Spacer(Modifier.height(8.dp))
        val label = stringResource(
            if (action == ProbeAction.FinalizePayment) {
                Res.string.probe_action_finalize
            } else {
                Res.string.probe_action_upgrade
            }
        )
        ProbePrimaryButton(
            text = label,
            color = if (action == ProbeAction.FinalizePayment) AppColor.StrikePrimary else ProbeOrange,
            onClick = { if (!busy) onAction() },
            modifier = Modifier.fillMaxWidth()
        )
    }
}

private const val MAP_LEVEL_COUNT = 18
private val MAP_FULL_SIZE = 256 shl MAP_LEVEL_COUNT

@Composable
internal fun StaticMapTile(
    lat: Double,
    lon: Double,
    radiusKm: Int = 100,
    modifier: Modifier = Modifier,
) {
    val googleApi = remember { GoogleProvider() }
    val tileStreamProvider = remember(googleApi) {
        TileStreamProvider { row, col, zoomLvl ->
            googleApi.getTile(row, col, zoomLvl)
        }
    }
    val center = remember { MapUtils.latLngToXY(lat, lon) }
    val density = LocalDensity.current
    val mapState = remember {
        val vpPx = with(density) { 200.dp.toPx() }
        val cosLat = cos(lat * PI / 180.0)
        // Show 1.5x the radius so the circle fits with padding
        val xRange = 2.0 * radiusKm * 1.5 / (40075.0 * cosLat)
        MapState(
            levelCount = MAP_LEVEL_COUNT,
            fullWidth = MAP_FULL_SIZE,
            fullHeight = MAP_FULL_SIZE,
            tileSize = 256,
        ) {
            scroll(center.x, center.y)
        }.apply {
            scale = vpPx / (MAP_FULL_SIZE.toDouble() * xRange)
        }
    }
    LaunchedEffect(Unit) {
        try { googleApi.initialize() } catch (_: Throwable) { }
        try { mapState.addLayer(tileStreamProvider) } catch (_: Throwable) { }
        // Coverage circle
        try {
            mapState.addPath(
                id = "coverage", width = 2.dp,
                color = Color(0xFFE63B2E)
            ) {
                MapUtils.circle(LatLng(lat, lon), radiusKm * 1000) {
                    MapUtils.latLngToXY(this).toPair()
                }?.let { list -> addPoints(list) }
            }
        } catch (_: Throwable) { }
        // Center marker
        try {
            mapState.addMarker("center", center.x, center.y) {
                Canvas(Modifier.size(12.dp)) {
                    val cx = size.width / 2
                    val cy = size.height / 2
                    drawCircle(Color(0xFFE63B2E), radius = 6f, center = Offset(cx, cy))
                    drawCircle(Color.White, radius = 2f, center = Offset(cx, cy))
                }
            }
        } catch (_: Throwable) { }
        try { mapState.snapScrollTo(center.x, center.y) } catch (_: Throwable) { }
    }
    FullscreenMapContainer(
        modifier = modifier.background(AppColor.StrikeBackground),
        controls = { isFullscreen -> if (isFullscreen) MapZoomControls(mapState) },
    ) { isFullscreen ->
        MapUI(
            modifier = Modifier.fillMaxSize(),
            state = mapState,
        )
        // Transparent overlay to disable map gestures (inline only, the full screen map is interactive)
        if (!isFullscreen) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Transparent)
                    .pointerInput(Unit) { /* consume all touch events */ }
            )
        }
    }
}

@Composable
internal fun KpiCard(
    modifier: Modifier = Modifier,
    value: String,
    label: String,
    valueColor: Color,
) {
    Column(
        modifier = modifier
            .clip(RoundedCornerShape(10.dp))
            .background(AppColor.StrikeCard)
            .padding(12.dp)
    ) {
        TextNormal(value, fontSize = 16.sp, fontWeight = FontWeight.ExtraBold, color = valueColor)
        TextNormal(label, fontSize = 10.sp, color = AppColor.StrikeText.copy(alpha = 0.6f))
    }
}

@Composable
internal fun LoadingCenter() {
    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        CircularProgressIndicator(color = AppColor.StrikePrimary)
    }
}

@Composable
internal fun ErrorCenter(msg: String?) {
    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        TextNormal(msg ?: "Erreur inconnue", fontSize = 14.sp, color = AppColor.StrikeDanger)
    }
}

@Composable
internal fun EmptyCenter(msg: String) {
    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        TextNormal(msg, fontSize = 14.sp, color = AppColor.StrikeText.copy(alpha = 0.5f))
    }
}

internal fun Long.toShortDateOrNull(): String? {
    if (this <= 0L) return null
    val dt = DateTime.fromUnixMillis(this * 1000).local
    val d = dt.dayOfMonth.toString().padStart(2, '0')
    val m = dt.month1.toString().padStart(2, '0')
    return "$d/$m/${dt.yearInt}"
}

internal fun Double.formatCoord4(): String {
    val absVal = abs(this)
    var intPart = absVal.toLong()
    var decPart = ((absVal - intPart) * 10000 + 0.5).toLong()
    if (decPart >= 10000) {
        intPart += 1
        decPart = 0
    }
    val sign = if (this < 0) "-" else ""
    return "$sign$intPart.${decPart.toString().padStart(4, '0')}"
}
